import Vue from 'vue'
import track from './utils/track'
import pageConf from './pageConf.js'
// import packageInfo from '../../../package.json'

import getActiveData from './utils/getActiveData'
import _shareInit from './utils/share.js'
import { VnLoginToast, BsGetEnv, BsUtil, BsGetXcx, BsGetCid } from 'dida-web-common'

let zhiyuxiaochengxuhoutai = true
// 处理页面自动刷新
async function handleAutoRefresh() {
    const { isAli, isWx } = await BsGetXcx()
    zhiyuxiaochengxuhoutai = !(isAli || isWx) // 小程序默认是false
    const { cid } = await BsGetCid()
    if (cid && pageConf?.options?.basic?.autoRefresh) {
        document.addEventListener('visibilitychange', function() {
            // 未登录无需刷新页面
            if (document.visibilityState === 'visible' && zhiyuxiaochengxuhoutai) {
                (isAli || isWx) && (zhiyuxiaochengxuhoutai = false)
                location.reload()
            } else {
                (isAli || isWx) && (zhiyuxiaochengxuhoutai = true)
            }
        })
    }
}

function initSentry(prodectName) {
    if (window.Sentry && pageConf?.options && pageConf.options.basic.sentry) {
        window.Sentry.init({
          Vue,
          release: prodectName + '@' + '1.0.0',
          environment: BsGetEnv.isEnvOnline ? 'online' : (BsGetEnv.isEnvECS ? 'simu' : 'test'),
          dsn: pageConf.options.basic.sentry,
          integrations: [
            new window.BrowserTracing({
            //   routingInstrumentation: Sentry.vueRouterInstrumentation(router),
              tracingOrigins: ['localhost', 'capis.didapinche.com', 'capis-ecs.didapinche.com', 'capis-test.didapinche.com']
            })
          ],
          tracesSampleRate: 1.0
        })
      }
}

export default function init(_v) {
    // eslint-disable-next-line prefer-const
    let { promotionCode, activityCode, url = '' } = pageConf.options.basic?.getDataMes || pageConf.options.basic
    const { prodectName } = pageConf.shareData
    promotionCode = BsUtil.queryString('promotionCode') || promotionCode
    activityCode = BsUtil.queryString('activityCode') || activityCode
    Vue.prototype.$track = track(prodectName, url.indexOf('promotion/act') > -1 ? promotionCode : '', activityCode && Array.isArray(activityCode) ? activityCode[0] : activityCode)
    _v.$root.$data.DATA = pageConf
    _v.$root.$data.productName = prodectName
    _v.$root.$data.shareData = pageConf?.shareData
    _v.$root.$data.activeData = { sceneCode: promotionCode, activityCode: activityCode }
    _v.$root.$data.updateInitData = (acCode, acType, conditionList, paramsList, fn) => {
        getActiveData(_v, acCode, acType, conditionList, paramsList, fn)
    }
    // 回到H5页面自动刷新
    const autoRefresh = pageConf?.options?.basic?.autoReload
    // 登录功能
    Vue.prototype.$Login = function(cb) {
        VnLoginToast.vnLogin({
            autoRefresh: !!autoRefresh,
            success: async(user) => {
                cb && cb(user)
                _v.$track.addStat('h5_will_enter_page')
                // const { isAli, isWx } = await BsGetXcx()

                // // 如果是小程序或者支付宝小程序，且配置了自动刷新，则不需要手动接口
                // if ((isAli || isWx) && pageConf?.options?.basic?.autoRefresh) {
                //    return
                // }
                _v.$bus.$emit('logined', { ...user })
                getActiveData(_v)
            }
        })
    }
    // 打开H5自动登陆
    const autoLogin = pageConf?.options?.basic?.autoLogin
    if (autoLogin === false) {
        VnLoginToast.vnLogin({
            autoRefresh: !!autoRefresh,
            success: () => {
                getActiveData(_v)
            }
        })
    } else {
        getActiveData(_v)
    }
    handleAutoRefresh()
    if (pageConf && pageConf.shareData) {
        _shareInit(pageConf.shareData)
    }
    initSentry(prodectName)
}
